/**
 * Template: Collection
 * ------------------------------------------------------------------------------
 * Main entry file for the Collection type templates.
 */
import '@/templates/collection.scss'

import CollectionRender from '~legacy-vue/CollectionRender'

/**
 * Load page contents.
 */
document.addEventListener('DOMContentLoaded', () => {
  CollectionRender().init()

  /**
   * Wait for BR to be ready before sending.
   */
  mint.EventBus.on('bloomreach:ready', () => {
    mint.EventBus.dispatch('bloomreach:trackEvent', {
      event: 'view_category',
      data: {
        category_path: location.pathname,
        category_title: mint.collection.title,
        location: location.href,
      },
    })
  })

  /**
   * Attraqt page view event.
   */
  mint.EventBus.on('attraqt:ready', () => {
    mint.EventBus.dispatch('attraqt:trackEvent', {
      'action': 'view',
      'target': {
        'page': location.pathname,
      },
      'metadata': {
        'locale': 'en_GB',
      },
    })
  })
})
